var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummerNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "smiling-sun") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "smiling-sun"
  }, /*#__PURE__*/React.createElement("g", {
    id: "label"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512,256c0,141.39-114.61,256-256,256S0,397.39,0,256,114.63,0,256,0,512,114.61,512,256Z",
    fill: "#ffce54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.29,256A101.28,101.28,0,1,1,256,154.71,101.29,101.29,0,0,1,357.29,256Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,278.53a42.75,42.75,0,0,1-79.42,0Z",
    fill: "#fc6e51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,362.76A106.76,106.76,0,1,1,362.77,256,106.89,106.89,0,0,1,256,362.76Zm0-202.57A95.81,95.81,0,1,0,351.81,256,95.91,95.91,0,0,0,256,160.19Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,261.47H389.82a5.47,5.47,0,1,1,0-10.95H421a5.47,5.47,0,1,1,0,10.95Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.19,261.47H91a5.47,5.47,0,1,1,0-10.95h31.17a5.47,5.47,0,0,1,0,10.95Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.64,127.65a5.48,5.48,0,0,1-5.48-5.47V91a5.48,5.48,0,0,1,11,0v31.15A5.48,5.48,0,0,1,256.64,127.65Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.15,172.33a5.46,5.46,0,0,1-3.87-1.6l-21.82-21.84a5.48,5.48,0,0,1,7.75-7.74L166,163a5.48,5.48,0,0,1-3.87,9.35Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.88,172.33A5.48,5.48,0,0,1,346,163l21.82-21.84a5.48,5.48,0,0,1,7.75,7.74l-21.82,21.84A5.46,5.46,0,0,1,349.88,172.33Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.64,426.46a5.48,5.48,0,0,1-5.48-5.48V389.82a5.48,5.48,0,0,1,11,0V421A5.48,5.48,0,0,1,256.64,426.46Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.32,372.45a5.48,5.48,0,0,1-3.87-9.35l21.82-21.83A5.48,5.48,0,0,1,166,349L144.2,370.85A5.46,5.46,0,0,1,140.32,372.45Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.69,372.45a5.44,5.44,0,0,1-3.87-1.61L346,349a5.47,5.47,0,0,1,7.75-7.74l21.82,21.83a5.48,5.48,0,0,1-3.87,9.35Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.22,236.48a5.48,5.48,0,0,1-5.48-5.47,7.77,7.77,0,0,0-15.54,0,5.48,5.48,0,0,1-11,0,18.73,18.73,0,0,1,37.45,0A5.48,5.48,0,0,1,307.22,236.48Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.29,236.48a5.48,5.48,0,0,1-5.48-5.47,7.77,7.77,0,0,0-15.54,0,5.48,5.48,0,0,1-11,0,18.73,18.73,0,0,1,37.45,0A5.48,5.48,0,0,1,231.29,236.48Z",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.73,310.92a48.08,48.08,0,0,1-44.79-30.35,5.48,5.48,0,0,1,5.08-7.52h79.42a5.47,5.47,0,0,1,5.08,7.52A48.1,48.1,0,0,1,255.73,310.92ZM225.15,284a37.27,37.27,0,0,0,61.17,0Z",
    fill: "#3d3d3d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummerNew);
export default __webpack_public_path__ + "static/media/summer-new.bc20668c8194a60c07e7c955ec681ee3.svg";
export { ForwardRef as ReactComponent };